<template>
	<div class="menus-wrap">
		<head-info></head-info>
		<div class="relative-wrap">
			<div style="position: relative;">
				<el-descriptions :column="2" title="考生行程信息" border>
					<el-descriptions-item label="姓名">{{ info.name }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<el-descriptions-item label="性别">{{ info.gender && info.gender === 1 ? '男' : info.gender && info.gender === 2 ? '女' : '-' }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<el-descriptions-item label="身份证号">{{ info.card_id || '-' }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<el-descriptions-item label="出生年月">{{ info.date_birth || '-' }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent', borderBottomColor: '#EBEEF5' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderBottomColor: '#EBEEF5', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<template v-for="(item, index) in info.details ? info.details : []">
						<el-descriptions-item v-if="+item.type === 5" :label="item.name" :span="2" :labelStyle="{ width: '150px' }">
							<div class="grid-wrap">
								<el-image
									v-for="(val, index) in item.value"
									:key="index"
									style="width: 100px; height: 100px;background-color: #f5f7fa;line-height: 100px;"
									:src="val.url"
									:preview-src-list="item.value.map(v => v.url)"
								>
									<div slot="error" style="text-align: center;"><i style="font-size: 30px;" class="el-icon-picture-outline"></i></div>
								</el-image>
							</div>
						</el-descriptions-item>
						<el-descriptions-item :span="2" v-else-if="+item.type === 4" :label="item.name">{{ item.value.join('、') }}</el-descriptions-item>
						<el-descriptions-item :span="2" v-else :label="item.name">{{ item.value }}</el-descriptions-item>
					</template>
				</el-descriptions>
				<div class="footer-btns">
					<el-button
						type="primary"
						@click="
							() => {
								this.$router.push('/travel/edit');
							}
						"
					>
						修改
					</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import { mapState } from 'vuex';
import { reqGetTravelInfo } from '@/api';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			info: {}
		};
	},
	computed: {
		...mapState({
			id: state => state.user.examinee.id,
			do_travel: state => state.user.examinee.do_travel,
			examination_id: state => state.system.examInfo.examination_id
		})
	},
	activated() {
	 	if(this.do_travel === 1){
	 		this.$router.push('/travel/form');
	 	}
		this.getInfo();
	},
	methods: {
		// 获取考生详情
		getInfo() {
			reqGetTravelInfo().then(res => {
				this.info = res.data;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.relative-wrap {
	position: relative;
	margin: 15px auto 0;
	max-width: 1000px;

	::v-deep.el-descriptions {
		padding: 0 20px;

		.el-descriptions__header {
			margin: 0;
			padding: 10px 0;
			justify-content: center;
			background-color: $--color-primary;
			color: #ffffff;

			.el-descriptions__title {
				font-weight: 500;
			}
		}

		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				line-height: 1.7;
			}

			.el-descriptions-item__content {
				max-width: 240px;
			}
			th.labelClassName {
				padding: 0;
			}
			th,
			td {
				padding-left: 30px;
			}
		}
	}

	::v-deep.labelClassName {
		&.el-descriptions-item__cell {
			padding: 0;
		}
	}
}

.grid-wrap {
	display: grid;
	grid-template-columns: repeat(3, 100px);
	grid-gap: 10px 10px;
}
</style>
